export default __webpack_public_path__ + "static/media/Message.b5d25eb0.svg";